import React, { useState, useEffect } from "react";
import {
  Button,
  DropOption,
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useForm } from "react-hook-form";
import { CFV, addAlpha } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteF,
  edit,
  seperation,
} from "../../../store/reducers/guestsReducer";
import GenericModal from "../../common/modals/GenericModal";
import telephone from "../../../assets/common/telephone.svg";
import trash from "../../../assets/common/trash.svg";
import girl from "../../../assets/common/girl.svg";
import boy from "../../../assets/common/boy.svg";
import separate from "../../../assets/common/separate.svg";
import call from "../../../assets/common/call.svg";
import callB from "../../../assets/common/callB.svg";
import sms from "../../../assets/common/sms.svg";
import whatsapp from "../../../assets/common/whatsapp.svg";
import tsim from "../../../assets/common/tsim.png";
import tiv from "../../../assets/common/tiv.png";
import glut from "../../../assets/common/glut.png";
import glat from "../../../assets/common/glat.png";
import YesNoModal from "../../common/modals/YesNoModal";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import OWC from "./OWC";
import dropdown from "../../../assets/common/dropdown.svg";

const Edit = ({ guest, init, categories, handleGetAll }) => {
  const { user, isTal } = useSelector((state) => state.authReducer);
  const [showDrop, setShowDrop] = useState(false);

  const dispatch = useDispatch();
  const { guestsLoading } = useSelector((state) => state.guestsReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      notes: guest.notes ?? "",
    },
  });
  const [showDelete, setShowDelete] = useState(null);
  const [limit, setLimit] = useState(true);
  const [loading, setLoadind] = useState(false);
  const [closeness, setCloseness] = useState(guest.closeness);
  const [show, setShow] = useState(true);
  const [owc, setOwc] = useState(
    guest.owc !== "" && guest.owc !== null ? guest.owc : "קשר",
  );
  const [ans, setAns] = useState(
    guest.ans !== "" && guest.ans !== null ? guest.ans : "",
  );
  const [history, setHistory] = useState(
    guest.history !== "" && guest.history !== null ? guest.history : "",
  );
  const [showDropOwc, setShowDropOwc] = useState(false);
  const [tempNotes, setNotes] = useState(false);
  const [tempAccept, setAccept] = useState(false);

  useEffect(() => {
    setValue("notes", guest.notes ?? "");
  }, [guest._id, guest.notes, setValue]);

  const handleOnSelect = (item) => {
    setCloseness(item.id);
  };
  const handleOnSearch = (string, results) => {
    setCloseness(string);
  };

  const handleSeperation = () => {
    dispatch(
      seperation({
        id: guest._id,
        acceptWomen: guest.acceptWomen,
        acceptMen: guest.acceptMen,
      }),
    ).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        handleGetAll();
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleAnsClick = (num, pos = "") => {
    // if (ans === "M" || ans === "W" || ans === "L")
    // toast.warning("לא ניתן לסמן מענה מכיוון שכבר התקבל דרך הודעה");
    // else {
    setAns(`C${num} - ${pos} נענתה`);
    setShowDrop(false);
    // }
  };

  const onSubmit = async (data) => {
    if (
      user.eventType &&
      ((data?.inviting.length && owc === "קשר") ||
        (data?.inviting.length === 0 && owc !== "קשר"))
    )
      toast.warning("שדה המזמין והקשר באים ביחד - הכל או כלום");
    else if (closeness.length > 1) {
      let phone = data.phone;
      if (phone[0] === "0") phone = phone.substring(1);
      phone = phone.replaceAll("-", "");
      phone = phone.replaceAll(/[^\d]/g, "");
      let reset = false;
      if (guest.phone?.length > 0 && guest.phone !== phone) reset = true;
      let notes =
        tempNotes !== false
          ? tempNotes
          : (data.notes ?? getValues("notes") ?? "");
      let accept;
      let acceptWomen;
      let acceptMen;
      if (user.separation) {
        accept = null;
        acceptWomen =
          data?.acceptWomen?.length < 1 ||
          data.acceptWomen === undefined ||
          data.acceptWomen === ""
            ? null
            : parseInt(data.acceptWomen);
        acceptMen =
          data?.acceptMen?.length < 1 ||
          data.acceptMen === undefined ||
          data.acceptMen === ""
            ? null
            : parseInt(data.acceptMen);
      } else {
        acceptWomen = null;
        acceptMen = null;
        accept =
          data.accept === undefined || data.accept === ""
            ? null
            : parseInt(data.accept);
      }
      if (user.separation && (acceptMen !== null || acceptWomen !== null)) {
        accept = 0;
        accept += acceptWomen !== null ? acceptWomen : 0;
        accept += acceptMen !== null ? acceptMen : 0;
      }
      if (tempAccept !== false) accept = tempAccept;
      // let arrived = data.arrived === undefined ? null : parseInt(data.arrived);
      let transportation =
        data.transportation === undefined
          ? null
          : parseInt(data.transportation);
      // Handle ans - keep ans as is (for current call status)
      let finalAns = ans === "מענה" ? "" : ans;

      // Handle history - append new ans to history string instead of overwriting
      // Use guest.history as base (from server) and append new ans if it changed
      let currentHistory = guest.history || "";
      let newHistory = currentHistory;

      if (finalAns && finalAns !== "") {
        // Check if the new ans is already the last entry in history (to avoid duplicates)
        const lastEntry = currentHistory.split(" | ").pop();
        if (lastEntry !== finalAns) {
          // Append new ans to existing history with separator
          if (currentHistory) {
            newHistory = `${currentHistory} | ${finalAns}`;
          } else {
            newHistory = finalAns;
          }
        } else {
          // Keep existing history if it's the same as the new one
          newHistory = currentHistory;
        }
      } else {
        // Keep existing history if no new ans
        newHistory = currentHistory;
      }

      let body = {
        phone,
        name: data.name,
        inviting: data.inviting,
        closeness,
        sum: parseInt(data.sum),
        ans: finalAns,
        history: newHistory,
        owc: owc === "קשר" ? "" : owc,
        dishes: [
          parseInt(data.glut),
          parseInt(data.tsim),
          parseInt(data.tiv),
          parseInt(data.glat),
        ],
        accept: reset ? null : accept,
        acceptMen: reset ? null : acceptMen,
        acceptWomen: reset ? null : acceptWomen,
        // arrived,
        transportation,
        notes: reset ? "" : notes === undefined ? "" : notes,
        // add table + gifts at be simple
      };
      if (reset) body = { ...body, smsSent: 0, whaSent: 0, paid: 0 };
      dispatch(edit(guest._id, body)).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          init();
        } else toast.error(res.payload?.error);
      });
    } else toast.warning("שדה קירבה לא יכול להיות פחות מ 2 תווים");
  };

  const handleDelete = () => {
    setLoadind(true);
    dispatch(deleteF([guest._id])).then((res) => {
      setLoadind(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      id="form1"
      style={{
        maxHeight: `${window.screen.availHeight * 0.9}px`,
        position: "relative",
        overflowY: "auto",
      }}
    >
      {user.separation && (
        <img
          onClick={handleSeperation}
          src={separate}
          style={{
            width: "30px",
            position: "absolute",
            left: "10px",
            top: "10px",
            cursor: "pointer",
          }}
        />
      )}
      <div
        style={{
          width: "90%",
          margin: "6px auto",
          paddingBottom: "6px",
        }}
      >
        <FlexRowBetween
          style={{
            margin: "4px auto",
            alignItems: "flex-end",
          }}
        >
          <div
            className="relativeBox"
            style={{
              zIndex: "1",
              width: "65%",
            }}
          >
            <Label
              style={{
                marginBottom: "2px",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              קירבה
            </Label>
            <ReactSearchAutocomplete
              items={categories}
              onSelect={handleOnSelect}
              onSearch={handleOnSearch}
              placeholder={closeness}
              fuseOptions={{ minMatchCharLength: 1 }}
              showNoResults={false}
              maxResults={show ? 10 : 0}
              styling={{
                searchIconMargin: "0 5px 0 10px",
                borderRadius: "8px",
                width: "100%",
                height: "34px",
                fontFamily: "system-ui, -apple-system, sans-serif",
                fontSize: "14px",
                border: "1px solid #e0e0e0",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              }}
            />
          </div>
          <OverlayTrigger
            placement={"bottom"}
            overlay={
              <Tooltip>
                {show ? "הסתרת השלמות לחיפוש" : "הצגת השלמות לחיפוש"}
              </Tooltip>
            }
          >
            <div
              style={{
                backgroundColor: "#7b96c4",
                color: "#ffffff",
                padding: "6px 14px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                fontSize: "13px",
                fontWeight: "400",
                fontFamily: "system-ui, -apple-system, sans-serif",
                boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
                marginBottom: "1px",
              }}
              onClick={() => setShow(!show)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#6a87b3";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(123, 150, 196, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#7b96c4";
                e.currentTarget.style.boxShadow =
                  "0 1px 3px rgba(123, 150, 196, 0.3)";
              }}
            >
              {show ? "הסתר" : "הצג"}
            </div>
          </OverlayTrigger>
        </FlexRowBetween>

        <FlexRowBetween style={{ marginTop: "8px" }}>
          <div style={{ width: "30%" }}>
            <Label
              style={{
                marginBottom: "2px",
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              שם מלא
            </Label>
            <Input
              defaultValue={guest.name}
              type="text"
              style={{
                padding: "6px 10px",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                fontSize: "14px",
                fontFamily: "system-ui, -apple-system, sans-serif",
                backgroundColor: "#ffffff",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#7b96c4";
                e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e0e0e0";
                e.target.style.boxShadow = "none";
              }}
              {...register("name", {
                required: true,
                minLength: 2,
                maxLength: 50,
              })}
            />
            {CFV("title", "בין 2 ל 50 תווים", errors)}
          </div>

          <div style={{ width: "40%" }}>
            <FlexRowBetween style={{ marginBottom: "-2px" }}>
              <Label style={{ fontSize: "13px", fontWeight: "500" }}>
                מס׳ נייד
              </Label>
              <OverlayTrigger
                placement={"bottom"}
                overlay={
                  <Tooltip>לחיצה תאפשר לשים מספר טלפון קווי לרשומה זו</Tooltip>
                }
              >
                <img
                  onClick={() => setLimit(!limit)}
                  src={telephone}
                  alt="telephone"
                  style={{
                    width: "18px",
                    marginLeft: "5px",
                    cursor: "pointer",
                    opacity: 0.7,
                    marginTop: "-5px",
                  }}
                />
              </OverlayTrigger>
            </FlexRowBetween>
            <Input
              defaultValue={guest.phone}
              style={{
                padding: "6px 10px",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                fontSize: "14px",
                fontFamily: "system-ui, -apple-system, sans-serif",
                backgroundColor: "#ffffff",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#7b96c4";
                e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e0e0e0";
                e.target.style.boxShadow = "none";
              }}
              {...register("phone", {
                pattern: limit && /^[0]{0,1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}
          </div>

          {guest.phone?.length && (
            <a
              href={
                "tel:" +
                (guest.phone[0] === "0" ? guest.phone : "0" + guest.phone + "")
              }
              // style={{ alignSelf: "flex-end", marginBottom: "2px" }}
            >
              <OverlayTrigger
                placement={"top"}
                overlay={<Tooltip>{"חיוג"}</Tooltip>}
              >
                <div
                  style={{
                    backgroundColor: "#7b96c4",
                    padding: "7.5px 7.5px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#6a87b3";
                    e.currentTarget.style.boxShadow =
                      "0 2px 6px rgba(123, 150, 196, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#7b96c4";
                    e.currentTarget.style.boxShadow =
                      "0 1px 3px rgba(123, 150, 196, 0.3)";
                  }}
                >
                  <img
                    alt="call"
                    style={{ width: "19px", filter: "brightness(0) invert(1)" }}
                    src={call}
                  />
                </div>
              </OverlayTrigger>
            </a>
          )}
        </FlexRowBetween>

        {/* History section - show SMS, WhatsApp, and call history */}
        {(guest.smsSent > 0 ||
          guest.whaSent > 0 ||
          (guest.history && guest.history !== "")) && (
          <div
            style={{
              marginTop: "6px",
              marginBottom: "6px",
              padding: "8px 10px",
              background: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #e8e8e8",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            <div
              style={{
                fontSize: "13px",
                fontWeight: "600",
                marginBottom: "4px",
                color: "#2c3e50",
                fontFamily: "system-ui, -apple-system, sans-serif",
              }}
            >
              היסטוריית פעולות:
            </div>
            {guest.smsSent > 0 && (
              <div
                style={{
                  fontSize: "12px",
                  marginBottom: "3px",
                  color: "#555",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <img
                  src={sms}
                  alt="SMS"
                  style={{ width: "14px", height: "14px" }}
                />
                הודעות SMS שנשלחו: {guest.smsSent}
              </div>
            )}
            {guest.whaSent > 0 && (
              <div
                style={{
                  fontSize: "12px",
                  marginBottom: "3px",
                  color: "#555",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <img
                  src={whatsapp}
                  alt="WhatsApp"
                  style={{
                    width: "19px",
                    height: "19px",
                    marginRight: "-3px",
                    marginLeft: "-2.5px",
                  }}
                />
                הודעות WhatsApp שנשלחו: {guest.whaSent}
              </div>
            )}
            {guest.history && guest.history !== "" && (
              <div
                style={{
                  fontSize: "12px",
                  marginBottom: "0px",
                  color: "#555",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                <img
                  src={callB}
                  alt="Call"
                  style={{
                    width: "14px",
                    height: "14px",
                  }}
                />
                שיחות טלפון: {guest.history}
              </div>
            )}
          </div>
        )}

        {/* Notes section - separate from history */}
        {isTal ? (
          // For isTal - editable TextArea
          <>
            <FlexRowBetween
              style={{
                alignItems: "center",
                marginTop: "6px",
                marginBottom: "2px",
              }}
            >
              <Label style={{ fontSize: "13px", fontWeight: "500" }}>
                הערות
              </Label>
              {guest.notes && guest.notes !== "" && (
                <div
                  onClick={() => {
                    setNotes("");
                    setValue("notes", "");
                  }}
                  style={{
                    padding: "4px 10px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(220, 53, 69, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(220, 53, 69, 0.1)";
                  }}
                  title="אפס הערות"
                >
                  <span
                    style={{
                      fontSize: "11px",
                      color: "#dc3545",
                      fontWeight: "600",
                      fontFamily: "system-ui, -apple-system, sans-serif",
                    }}
                  >
                    איפוס
                  </span>
                </div>
              )}
            </FlexRowBetween>
            <TextArea
              defaultValue={guest.notes}
              type="text"
              rows="2"
              style={{
                padding: "6px 10px",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                fontSize: "14px",
                fontFamily: "system-ui, -apple-system, sans-serif",
                backgroundColor: "#ffffff",
                transition: "all 0.2s ease",
                resize: "vertical",
                minHeight: "50px",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#7b96c4";
                e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e0e0e0";
                e.target.style.boxShadow = "none";
              }}
              {...register("notes", {
                minLength: 0,
                maxLength: 500,
              })}
            />
            {CFV("notes", "עד 500 תווים", errors)}
          </>
        ) : (
          // For non-isTal - display only with nice styling like history
          guest.notes &&
          guest.notes !== "" && (
            <div
              style={{
                marginTop: "6px",
                marginBottom: "6px",
                padding: "8px 10px",
                background: "#f8f9fa",
                borderRadius: "8px",
                border: "1px solid #e8e8e8",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  marginBottom: "4px",
                  color: "#2c3e50",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
              >
                הערות:
              </div>
              <div
                style={{
                  fontSize: "13px",
                  color: "#555",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  lineHeight: "1.5",
                }}
              >
                {guest.notes}
              </div>
            </div>
          )
        )}

        <FlexRowBetween style={{ marginTop: "6px" }}>
          <div style={{ width: "20%" }}>
            <Label
              style={{
                fontSize: "13px",
                fontWeight: "500",
                padding: "2px 2px",
                marginBottom: "0px",
              }}
            >
              הוזמנו
            </Label>
            <Input
              defaultValue={guest.sum}
              type="number"
              style={{
                padding: "6px 10px",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                fontSize: "14px",
                fontFamily: "system-ui, -apple-system, sans-serif",
                backgroundColor: "#ffffff",
                transition: "all 0.2s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#7b96c4";
                e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e0e0e0";
                e.target.style.boxShadow = "none";
              }}
              {...register("sum", {
                required: true,
                min: 1,
                max: user.acceptLimit,
              })}
            />
            {CFV(`sum`, `מספר בין 1 ל ${user.acceptLimit}`, errors)}
          </div>
          <div style={{ width: "20%" }}>
            <Label
              style={{
                fontSize: "13px",
                fontWeight: "500",
                backgroundColor: "#e8f0fe",
                color: "#183d81ff",
                padding: "2px 2px",
                marginBottom: "0px",
                paddingLeft: "8px",
                borderRadius: "6px",
                width: "fit-content",
                textAlign: "right",
                display: "block",
              }}
            >
              אישרו
            </Label>
            <div style={{ position: "relative", width: "100%" }}>
              <Input
                defaultValue={guest.accept}
                disabled={user.separation}
                type="number"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("accept", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {ans !== "" && (
                <div
                  style={{
                    position: "absolute",
                    left: "6px",
                    top: "8px",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    background: addAlpha("#7b96c4", 0.15),
                    fontSize: "11px",
                    fontWeight: "600",
                    color: "#5377bb",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                  }}
                >
                  {ans.split("-")[0]}
                </div>
              )}
            </div>
            {CFV(`accept`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
          </div>
          {user.separation ? (
            <>
              <div style={{ width: "20%" }}>
                <FlexRowBetween
                  style={{ width: "min-content", marginBottom: "2px" }}
                >
                  <img src={boy} alt="boy" style={{ width: "22px" }} />
                </FlexRowBetween>
                <Input
                  defaultValue={guest.acceptMen}
                  type="number"
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    backgroundColor: "#ffffff",
                    transition: "all 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#7b96c4";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(123, 150, 196, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e0e0e0";
                    e.target.style.boxShadow = "none";
                  }}
                  {...register("acceptMen", {
                    min: 0,
                    max: user.acceptLimit,
                  })}
                />
                {CFV(`acceptMen`, `מספר בין 1 ל ${user.acceptLimit}`, errors)}
              </div>
              <div style={{ width: "20%" }}>
                <FlexRowBetween
                  style={{ width: "min-content", marginBottom: "2px" }}
                >
                  <img src={girl} alt="girl" style={{ width: "22px" }} />
                </FlexRowBetween>
                <Input
                  defaultValue={guest.acceptWomen}
                  type="number"
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                    backgroundColor: "#ffffff",
                    transition: "all 0.2s ease",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#7b96c4";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(123, 150, 196, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e0e0e0";
                    e.target.style.boxShadow = "none";
                  }}
                  {...register("acceptWomen", {
                    min: 0,
                    max: user.acceptLimit,
                  })}
                />
                {CFV(`acceptWomen`, `מספר בין 1 ל ${user.acceptLimit}`, errors)}
              </div>
            </>
          ) : null}

          {/* <div style={{ width: "20%" }}>
            <Label>הגיעו</Label>
            <Input
              defaultValue={guest.arrived}
              type="number"
              {...register("arrived", {
                min: 0,
                max: user.acceptLimit,
              })}
            />
            {CFV(`arrived`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
          </div> */}

          {user.transportation && (
            <div style={{ width: "20%" }}>
              <Label
                style={{
                  marginBottom: "2px",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
              >
                הסעה
              </Label>
              <Input
                defaultValue={guest.transportation}
                type="number"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("transportation", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(
                `transportation`,
                `מספר בין 0 ל ${user.acceptLimit}`,
                errors,
              )}
            </div>
          )}
        </FlexRowBetween>

        {user.specialDishes && (
          <FlexRowBetween style={{ marginTop: "6px" }}>
            <div style={{ width: "20%" }}>
              <img
                src={glut}
                alt="glut"
                style={{ width: "30px", marginBottom: "2px" }}
              />
              <Input
                defaultValue={guest.dishes[0]}
                type="number"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("glut", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`glut`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>

            <div style={{ width: "20%" }}>
              <img
                src={tsim}
                alt="tsim"
                style={{ width: "32px", marginBottom: "2px" }}
              />
              <Input
                defaultValue={guest.dishes[1]}
                type="number"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("tsim", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`tsim`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>

            <div style={{ width: "20%" }}>
              <img
                src={tiv}
                alt="tiv"
                style={{ width: "32px", marginBottom: "2px" }}
              />
              <Input
                defaultValue={guest.dishes[2]}
                type="number"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("tiv", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`tiv`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>

            <div style={{ width: "20%" }}>
              <img
                src={glat}
                alt="glat"
                style={{ width: "30px", marginBottom: "2px" }}
              />
              <Input
                defaultValue={guest.dishes[3]}
                type="number"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("glat", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`glat`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>
          </FlexRowBetween>
        )}

        {user.eventType ? (
          <FlexRowBetween
            style={{
              marginTop: "6px",
              alignItems: "center",
            }}
          >
            <div style={{ position: "relative", width: "65%" }}>
              <Label
                style={{
                  marginBottom: "2px",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
              >
                המזמין
              </Label>
              <Input
                defaultValue={guest.inviting}
                type="text"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("inviting", {
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV("inviting", "בין 2 ל 50 תווים", errors)}
            </div>
            <OverlayTrigger
              placement={"bottom"}
              overlay={<Tooltip>{"הקשר של בעל/ת השמחה למזמין"}</Tooltip>}
            >
              <div
                style={{
                  backgroundColor: "#7b96c4",
                  color: "#ffffff",
                  padding: "7px 14px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontSize: "14px",
                  fontWeight: "400",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  // marginTop: "3px",
                  position: "relative",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropOwc(!showDropOwc);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#6a87b3";
                  e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(123, 150, 196, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#7b96c4";
                  e.currentTarget.style.boxShadow =
                    "0 1px 3px rgba(123, 150, 196, 0.3)";
                }}
              >
                <span>{owc}</span>
                <img
                  src={dropdown}
                  alt={"dropdown"}
                  style={{
                    width: "20px",
                    height: "20px",
                    filter: "brightness(0) invert(1)",
                  }}
                />
                {showDropOwc && (
                  <OWC
                    setOwc={setOwc}
                    setShowDropOwc={setShowDropOwc}
                    top={"-370%"}
                  />
                )}
              </div>
            </OverlayTrigger>
          </FlexRowBetween>
        ) : isTal ? (
          <FlexRowBetween
            style={{
              marginTop: "6px",
              alignItems: "center",
            }}
          >
            <div style={{ position: "relative", width: "65%" }}>
              <Label
                style={{
                  marginBottom: "2px",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
              >
                הוספת תיאור על מנת שהאורח יבין במי מדובר
              </Label>
              <Input
                defaultValue={guest.inviting}
                type="text"
                style={{
                  padding: "6px 10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register("inviting", {
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV("inviting", "בין 2 ל 50 תווים", errors)}
            </div>
          </FlexRowBetween>
        ) : null}

        {isTal && (
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip>{"מענה"}</Tooltip>}
          >
            <div
              style={{
                backgroundColor: "#7b96c4",
                color: "#ffffff",
                padding: "8px 14px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "system-ui, -apple-system, sans-serif",
                boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "6px",
                marginBottom: "10px",
                position: "relative",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowDropOwc(false);
                setShowDrop(!showDrop);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#6a87b3";
                e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(123, 150, 196, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#7b96c4";
                e.currentTarget.style.boxShadow =
                  "0 1px 3px rgba(123, 150, 196, 0.3)";
              }}
            >
              <span>{ans === "" ? "מענה" : ans}</span>
              <img
                src={dropdown}
                alt={"dropdown"}
                style={{
                  width: "20px",
                  height: "20px",
                  filter: "brightness(0) invert(1)",
                }}
              />
              {showDrop && isTal && (
                <div
                  style={{
                    position: "absolute",
                    right: "0",
                    bottom: "130%",
                    zIndex: 1,
                    color: "#7b96c4",
                    borderRadius: "8px",
                    backgroundColor: "white",
                    padding: "12px",
                    fontSize: "13px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    border: "1px solid #e8e8e8",
                    minWidth: "200px",
                  }}
                >
                  <FlexRowBetween>
                    <FlexRowBetween>
                      <div
                        onClick={() => handleAnsClick(1)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        כן
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          marginRight: "8px",
                          fontSize: "12px",
                          color: "#666",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                        }}
                      >
                        C1
                      </div>
                      <div
                        onClick={() => handleAnsClick(1, "לא ")}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        לא
                      </div>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "10px" }}>
                    <FlexRowBetween>
                      <div
                        onClick={() => handleAnsClick(2)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        כן
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          marginRight: "8px",
                          fontSize: "12px",
                          color: "#666",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                        }}
                      >
                        C2
                      </div>
                      <div
                        onClick={() => handleAnsClick(2, "לא ")}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        לא
                      </div>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "10px" }}>
                    <FlexRowBetween>
                      <div
                        onClick={() => handleAnsClick(3)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        כן
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          marginRight: "8px",
                          fontSize: "12px",
                          color: "#666",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                        }}
                      >
                        C3
                      </div>
                      <div
                        onClick={() => handleAnsClick(3, "לא ")}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        לא
                      </div>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "10px" }}>
                    <FlexRowBetween>
                      <div
                        onClick={() => handleAnsClick(4)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        כן
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          marginRight: "8px",
                          fontSize: "12px",
                          color: "#666",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                        }}
                      >
                        C4
                      </div>
                      <div
                        onClick={() => handleAnsClick(4, "לא ")}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        לא
                      </div>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "10px" }}>
                    <FlexRowBetween>
                      <div
                        onClick={() => handleAnsClick(5)}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        כן
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          marginRight: "8px",
                          fontSize: "12px",
                          color: "#666",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                        }}
                      >
                        C5
                      </div>
                      <div
                        onClick={() => handleAnsClick(5, "לא ")}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "6px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e0e0e0",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          fontSize: "12px",
                          fontFamily: "system-ui, -apple-system, sans-serif",
                          fontWeight: "400",
                          color: "#333",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                          e.currentTarget.style.borderColor = "#7b96c4";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e0e0e0";
                        }}
                      >
                        לא
                      </div>
                    </FlexRowBetween>
                  </FlexRowBetween>
                </div>
              )}
            </div>
          </OverlayTrigger>
        )}

        {isTal && (
          <div style={{ marginTop: "8px", marginBottom: "8px" }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <button
                type="submit"
                form="form1"
                style={{
                  fontSize: "12px",
                  color: "#333",
                  border: "1px solid #ddd",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontWeight: "400",
                }}
                onClick={() => setAccept(0)}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.borderColor = "#7b96c4";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                0
              </button>
              {!user.separation && (
                <>
                  <button
                    type="submit"
                    form="form1"
                    style={{
                      fontSize: "12px",
                      color: "#333",
                      border: "1px solid #ddd",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "#ffffff",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      fontFamily: "system-ui, -apple-system, sans-serif",
                      fontWeight: "400",
                    }}
                    onClick={() => setAccept(1)}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f8f9fa";
                      e.target.style.borderColor = "#7b96c4";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#ffffff";
                      e.target.style.borderColor = "#ddd";
                    }}
                  >
                    1
                  </button>
                  <button
                    type="submit"
                    form="form1"
                    style={{
                      fontSize: "12px",
                      color: "#333",
                      border: "1px solid #ddd",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "#ffffff",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      fontFamily: "system-ui, -apple-system, sans-serif",
                      fontWeight: "400",
                    }}
                    onClick={() => setAccept(2)}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f8f9fa";
                      e.target.style.borderColor = "#7b96c4";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#ffffff";
                      e.target.style.borderColor = "#ddd";
                    }}
                  >
                    2
                  </button>
                </>
              )}
              <button
                type="submit"
                form="form1"
                style={{
                  fontSize: "12px",
                  color: "#333",
                  border: "1px solid #ddd",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontWeight: "400",
                }}
                onClick={() =>
                  setNotes(
                    "לא יודעים כרגע, לא להתקשר יותר - יעדכנו בקישור במידה ויהיה שינוי",
                  )
                }
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.borderColor = "#7b96c4";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                לא להתקשר + יעדכנו
              </button>
              <button
                type="submit"
                form="form1"
                style={{
                  fontSize: "12px",
                  color: "#333",
                  border: "1px solid #ddd",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontWeight: "400",
                }}
                onClick={() => {
                  setNotes(
                    "לא לקחת בחשבון כרגע, יעדכנו בקישור במידה ויהיה שינוי",
                  );
                  setAccept(0);
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.borderColor = "#7b96c4";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                0 + יעדכנו
              </button>
              <button
                type="submit"
                form="form1"
                style={{
                  fontSize: "12px",
                  color: "#333",
                  border: "1px solid #ddd",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontWeight: "400",
                }}
                onClick={() => {
                  setNotes("טעות במספר");
                  setAccept(0);
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.borderColor = "#7b96c4";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                טעות
              </button>
              <button
                type="submit"
                form="form1"
                style={{
                  fontSize: "12px",
                  color: "#333",
                  border: "1px solid #ddd",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  backgroundColor: "#ffffff",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontWeight: "400",
                }}
                onClick={() => setNotes("מספר לא מחובר")}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.borderColor = "#7b96c4";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#ddd";
                }}
              >
                מספר לא מחובר
              </button>
            </div>
          </div>
        )}

        <FlexRowBetween style={{ marginTop: "12px", marginBottom: "12px" }}>
          <Button
            style={{
              width: "100%",
              background: "#7b96c4",
              color: "#ffffff",
              border: "none",
              borderRadius: "8px",
              padding: "8px 20px",
              fontSize: "15px",
              fontWeight: "400",
              fontFamily: "system-ui, -apple-system, sans-serif",
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
            }}
            type="submit"
            form="form1"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#6a87b3";
              e.currentTarget.style.boxShadow =
                "0 2px 6px rgba(123, 150, 196, 0.4)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#7b96c4";
              e.currentTarget.style.boxShadow =
                "0 1px 3px rgba(123, 150, 196, 0.3)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            שמירה
          </Button>
          <div
            onClick={() => setShowDelete(true)}
            style={{
              backgroundColor: "#6a7a8a",
              color: "#ffffff",
              padding: "10px 12px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              marginRight: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 1px 3px rgba(106, 122, 138, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#49647fff";
              e.currentTarget.style.boxShadow =
                "0 2px 6px rgba(106, 122, 138, 0.4)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#4c7196ff";
              e.currentTarget.style.boxShadow =
                "0 1px 3px rgba(106, 122, 138, 0.3)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <img src={trash} alt="trash" style={{ width: "18px" }} />
          </div>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
      {guestsLoading && <OpacityLoading />}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת רשומה"}
              body={"האם את/ה בטוח/ה שברצונך למחוק רשומה זו?"}
              no={setShowDelete}
              yes={handleDelete}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default Edit;
